/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2021 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/


import React, { Component } from 'react';
import style from '../../component/common/style/index.scss';
import asyncCallHandler from '../../common/utils/asyncCallHandler'
import { formatDateUrl } from '../../common/utils/index'
import EDW_CONST from '../../common/constants';
import { EdwLoaderWithContainer } from '../common/edwLoaderWithContainer/EdwLoaderWithContainer';
import { EdwTooltip} from '../common/ToolTip/EdwTooltip'
import { BaselineTargetNoData } from "../common/noData/NoData";

export class StudentAssessmentInfo extends React.Component {
    constructor(props) {
        super();
        this.state = { 
                    isDataFetch:false,
                   assessmentInfo:[]
                };
        
        this.iesToken = props.token ? props.token : ''
      }
     componentDidMount() {
         this.fetchStudentInfo();
    }  

     componentDidUpdate(prevProps) {
         if(prevProps.groupId !== this.props.groupId || prevProps.courseId !== this.props.courseId){
            this.fetchStudentInfo();
         }
    } 
    
     fetchStudentInfo(){
        let { studentId, groupId, schoolId, courseId} = this.props;
        asyncCallHandler(EDW_CONST.STUDENT_END_POINT, `studentDetails?studentId=${studentId}&schoolId=${schoolId}&groupId=${groupId}&courseId=${courseId}`, this.iesToken).then(response => {
            this.props.onStudentDetilsResponse(response.data)
            this.setState({ assessmentInfo: response.data, isDataFetch:true})
        }).catch((error) => {
            console.log("axios error:", error);
        }); 
    }
     showInfo(){

         const colorClass = (this.state.assessmentInfo.studentOnTrack == "Below" && this.state.assessmentInfo.studentOnTrack != null) ? "col-md info-color-red" : (this.state.assessmentInfo.studentOnTrack == "On or above" && this.state.assessmentInfo.studentOnTrack != null) ? "col-md info-color-green" :"col-md";
         const colorClass2 = (this.state.assessmentInfo.gradeProgress < 0 && this.state.assessmentInfo.gradeProgress != null) ? "col-md info-color-red" : (this.state.assessmentInfo.gradeProgress >= 0 && this.state.assessmentInfo.gradeProgress != null) ? "col-md info-color-green" : "col-md";

        return(
            <div className="row content-row-padding info">
                <div className="col-md-2">
                    <span className="label-cls">Baseline</span>
                    <span className="value-cls">{this.state.assessmentInfo.baseGrade}</span>
                </div>
                <div className="col-md-2 info-border">
                    <span className="label-cls">Course target</span>
                    <span className="value-cls">{this.state.assessmentInfo.targetGrade}</span>
                </div>
                <div className="col-md-2 info-border">
                    <span className={colorClass}>
                        <span className="label-cls">On track?</span>
                        <EdwTooltip title="The last assessment result indicates the student is ‘on or above’ or ‘below’ track to meet their course target. Based on linear progress from baseline to course target (excluding unit tests)." >
                        </EdwTooltip>
                        <span className="value-cls">{this.state.assessmentInfo.studentOnTrack}</span>
                    </span>
                </div>
                <div className="col-md-2">
                    <span className={colorClass2}>
                        <span className="label-cls">Progress</span>

                        <EdwTooltip title="Progress is the difference in indicative grades between the latest assessment and the baseline test (excluding unit tests)." >
                        </EdwTooltip>

                        <span className="value-cls">{this.state.assessmentInfo.gradeProgress}</span>
                    </span>
                </div>
                </div>
            
        )
    }
    
    render() {
        return (
            (this.state.isDataFetch && this.state.assessmentInfo.gradeProgress != null && this.state.assessmentInfo.targetGrade != null) ? this.showInfo() : (this.state.isDataFetch && (this.state.assessmentInfo.gradeProgress == null || this.state.assessmentInfo.targetGrade == null)) ? <BaselineTargetNoData/> : <EdwLoaderWithContainer />
               )
    }
}





